
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/datastore",
      function () {
        return require("private-next-pages/datastore/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/datastore"])
      });
    }
  